// --------- This should be moved to a separate business logic file in the new widgets package ---------

const KM_IN_MILE = 1.609344

export const convertKmToMiles = (distance: number): number => {
  return distance / KM_IN_MILE
}
